import { Role, UserRoleEnum } from 'generated/graphql';

export const userRole = (roles: string[], user?: { role: Role | UserRoleEnum } | null) => {
  if (!user) return false;
  return roles.includes(user.role);
};
